import { createAsyncTypes } from 'utils/ActionCreator'

export const EULA_TYPES = {
  1: 'full',
  2: 'pov',
  3: 'starter',
}

const key = 'EULAModal'

export const SUBMIT_EULA_ASYNC = createAsyncTypes('SUBMIT_EULA', key)

export const eulaUrls = {
  starter:
    'https://www.ironscales.com/hubfs/PDFs/IronScales%20-%20Freemium%20EULA%20-%20September%2030%202021.pdf',
  pov: 'https://www.ironscales.com/hubfs/PDFs/Ironscales%20Evaluation%20Terms%20and%20Conditions%20-%2028Sept22.pdf',
  full: 'https://www.ironscales.com/hubfs/Ironscales%20EULA%20Template%20(September%202026).pdf',
}

export const getEulaUrl = (type) => eulaUrls[EULA_TYPES[type]]
